import React from 'react'
import { HStack, Switch, Text, Box, useColorModeValue } from '@chakra-ui/react'
import { useColorMode } from '@chakra-ui/color-mode'

function SunGlyph(props) {
	return (
		<Box
			as="svg"
			width="18px"
			height="18px"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			flexShrink={0}
			aria-hidden
			{...props}
		>
			<circle cx="12" cy="12" r="4" />
			<path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
		</Box>
	)
}

function MoonGlyph(props) {
	return (
		<Box
			as="svg"
			width="18px"
			height="18px"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			flexShrink={0}
			aria-hidden
			{...props}
		>
			<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
		</Box>
	)
}

export default function ColorModeToggle(props) {
	const { colorMode, toggleColorMode } = useColorMode()
	const isDark = colorMode === 'dark'

	const activeColor = useColorModeValue('brand.600', 'orange.100')
	const mutedColor = useColorModeValue('gray.400', 'gray.400')
	const labelColor = useColorModeValue('gray.600', 'gray.200')

	return (
		<HStack
			spacing={2}
			align="center"
			pl={{ base: 2, md: 3 }}
			ml={{ base: 0, md: 1 }}
			borderLeftWidth={{ base: 0, md: '1px' }}
			borderColor={useColorModeValue('gray.200', 'whiteAlpha.400')}
			{...props}
		>
			<Text
				fontSize="xs"
				fontWeight="600"
				color={labelColor}
				textTransform="uppercase"
				letterSpacing="0.06em"
				display={{ base: 'none', sm: 'block' }}
			>
				Theme
			</Text>
			<HStack spacing={2} align="center">
				<SunGlyph color={!isDark ? activeColor : mutedColor} />
				<Switch
					isChecked={isDark}
					onChange={toggleColorMode}
					colorScheme="brand"
					size="md"
					aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
				/>
				<MoonGlyph color={isDark ? activeColor : mutedColor} />
			</HStack>
		</HStack>
	)
}
